<template>
	<template v-if="orders?.length">
		<div class="orders-header">
			<BaseCmsLabel code="order_no" class="col-order-num" tag="div" />
			<BaseCmsLabel code="date" class="col-date-order-num" tag="div" />
			<BaseCmsLabel code="status" class="col-order-status" tag="div" />
			<BaseCmsLabel code="total" class="col-order-total" tag="div" />
		</div>
		<div class="orders">
			<BaseUiAccordion>
				<BaseUiAccordionPanel v-for="item in visibleOrders" :key="item.id" :id="item.id" v-slot="{onToggle, active}">
					<div class="order-row" :class="{'active': active}">
						<div class="table-order" @click="onToggle">
							<div class="table-col col-order-num">{{item.id}}</div>
							<div class="table-col col-date-order-num"><BaseUtilsFormatDate :date="item.datetime_created" /></div>
							<div class="table-col col-order-status"><BaseCmsLabel code="status" />: {{item.status.title}}</div>
							<div class="table-col col-order-total"><BaseUtilsFormatCurrency :price="item.total" /></div>
							<div class="table-col col-order-btns">
								<div class="btn-order-details">
									<span class="btn-inactive" v-if="!active"><BaseCmsLabel code="webshop_btn_order_details" /><span class="plus"></span></span>
									<span class="btn-active" v-else><BaseCmsLabel code="webshop_btn_hide_order_details" /><span class="plus"></span></span>
								</div>
							</div>
						</div>
						<div v-if="item.order_items" v-show="active" class="order-details">
							<div class="w-table w-table-details">
								<AuthOrderItem v-for="product in item.order_items" :product="product" :key="product.id" />
							</div>
							<NuxtLink v-if="item?.satisfaction_survey_allowed && item?.satisfaction_survey_url" :to="item.satisfaction_survey_url" class="btn btn-primary btn-satisfaction">
								<span><BaseCmsLabel code="profile_satisfaction_btn" /></span>								
							</NuxtLink>
						</div>
					</div>
				</BaseUiAccordionPanel>
			</BaseUiAccordion>
		</div>
	</template>
	<BaseCmsLabel code="auth_no_orders" class="auth-no-orders" tag="div" v-else />
</template>

<script setup>
	const props = defineProps(['orders','mode']);
	const visibleOrders = computed(() => {
		return props.mode === 'dashboard' ? props.orders.slice(0, 5) : props.orders;
	});
</script>

<style lang="less" scoped>
	.btn-satisfaction{height: 50px; min-width: 120px; margin: 20px 0;}
</style>
